import "@tennr/style/index.css";

// Universal
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";
import { PageBackground } from "@tennr/frontend/components/PageBackground";
import { SiteFooter } from "@tennr/frontend/components/SiteFooter";
import { Link } from "@tanstack/react-router";
import { VideoPlayer } from "@tennr/frontend/components/VideoPlayer";


import './FaxItPage.css';
import { Button } from "@tennr/frontend/components/Button";
import { Heading } from "@tennr/frontend/components/Heading";
import { FractalFrame } from "@tennr/frontend/components/FractalFrame/FractalFrame";

export function FaxItPage(){
    return(
        <>
            <VideoPlayer className="video-hero" {...{ poster: "/img/fax-it/poster.jpg", source: "https://vimeo.com/1091985538/ae2eab818c", mobileSource: "https://vimeo.com/1092803856/8d49079d2a", mobilePoster: "/img/fax-it/mobile-poster.jpg" }}>
                <h2>F*xing Isn’t the Problem.</h2>
                <Button
                    text=" "
                    iconPath="/svg/play.svg"
                    iconPos="left"
                    minWidth={113}
                    minHeight={64}
                    backgroundColorLight="#9B4E45"
                    backgroundColorDark="#9B4E45"
                    textColorLight="#FFFFFF"
                    textColorDark="#FFFFFF"
                    staticTextColor="#FFFFFF"
                    dynamicContrast={true}
                    dontAnimateIntro={true}
                  
                />     
                <div className="keep-scrolling">
                    <span>KEEP SCROLLING</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="19" viewBox="0 0 7 19" fill="none">
                        <path d="M3.5 19L6.38675 14L0.613249 14L3.5 19ZM3.5 0L3 2.18556e-08L3 14.5L3.5 14.5L4 14.5L4 -2.18556e-08L3.5 0Z" fill="white"/>
                    </svg>
                </div>   
            </VideoPlayer>        
        <section className="fax-it-content">    
            <div className="two-up blocks swap-sm">
                <div className="text block">
                    <p>Meet John, the youngest of two brothers at a family company: Advanced Reliable Premier Medical.</p>
                    <p>John runs customer service. His brother, Casey, runs… pretty much everything else. Casey’s always looking to grow margins, process more patients, reduce denials — you know, the business stuff. </p>
                </div>
                <div className="image block">
                    <FractalFrame>
                        <img style={{ maxWidth: '427px'}} src="/img/fax-it/thumb-1.jpg" alt="F*xing Isn’t the Problem." />
                    </FractalFrame>
                </div>
            </div>
            <div className="two-up blocks">
                <div className="image block">
                    <img src="/img/fax-it/printer.png" alt="Fax Machine, printer" />
                </div>
                <div className="text block">
                    <p>It was at That Big Conference in Dallas. Casey was scouring the exhibit floor, talking to vendors, taking business cards, while John was… looking for free stuff. On the second day John saw a lady walk by with a frozen margarita in a light up cup. </p>
                    <p>“Excuse me, where’d you get that?” She pointed to a booth in the corner by the food stands. “Thanks.”</p>
                    <p>John walked over and sure enough there it was: a booth with a bartender and two frozen margarita machines. <em>Don’t mind if I do.</em></p>
                </div>
            </div>
            <div className="two-up blocks swap-sm">
                <div className="text block">
                    <p>John got in line for his frozen marg when a tall strapping young man approached him. “Have you heard of Tennr?”</p>
                    <p>“Nope, what’s Tennr?”</p>
                    <p>“We’re a frozen margarita company.”</p>
                    <p>John chuckled. How many times has he said that line today?</p>
                    <p>“Kidding. We’re a machine-learning company out of the Stanford AI lab. We help providers capture more referrals, reduce first-pass denials, and achieve efficient scalability.”</p>
                    <p>Right then, Casey walked up.</p>
                    <p>“You’re gonna want to hear this,” John said. He turned to the bartender, “Can you make that two?”</p>
                </div>
                <div className="video block">
                    <FractalFrame>
                        <VideoPlayer  {...{ poster: "/img/fax-it/thumb-2.jpg", source: "https://vimeo.com/1092538469/0796d6f45d" }} />
                    </FractalFrame>
                </div>    
            </div>
            <div className="full-width block fax-cta">
                 <Heading className="fax-heading" position="center" heading="eFax, email, e-prescribe. Tennr handles it all." body="Because f*xing isn’t the problem."/>
                <Link to="/demo">
                    <Button {...{
                            text: "See How",
                            backgroundColorLight: "#FBFBF9",
                            backgroundColorDark: "#FBFBF9",
                            width: 250,
                            height: 58,
                            staticTextColor: "#9B4E45",
                        } 
                    }/>
                </Link>
            </div>
            <div className="full-width blocks full-height bg-cover hide-mobile" style={{ backgroundImage: `url('/img/fax-it/bottom-image.png')` }}>                
            </div>
            <div className="full-width blocks full-height bg-cover mobile-only" style={{ backgroundImage: `url('/img/fax-it/mobile-bottom-image.jpg')` }}>                
            </div>
        </section>  
        <SiteFooter taglinePosition="left" bgImage="/img/footer-demo-bg.jpg" bgImageVert="/img/footer-demo-bg-vert.jpg" />
              
        </>
    )
}

